import { Component, inject } from '@angular/core';

import { DynamicDialogRef } from 'primeng/dynamicdialog';

import { slideInRight } from '../../helpers/reusableAnimations';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'qw-welcome-modal',
    templateUrl: './welcome-modal.component.html',
    styleUrls: ['./welcome-modal.component.scss'],
    animations: [slideInRight],
    standalone: true,
    imports: [FaIconComponent],
})
export class WelcomeModalComponent {

    public modal = inject(DynamicDialogRef);

    public startTour() {
        this.modal.close('start-tour');
    }
}
